import React, { useEffect,useState } from "react";

import config from "../config";
import axios from "axios";
import { useNavigate,Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader"; 
import "./login.css";
import { Header } from "./header";
import { Aside } from "./aside";
import { Footer } from "./footer";
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import moment from 'moment-timezone';
function Appcontent() {
  const navigate = useNavigate();
  let   [loadingInProgress, setLoading] = useState(false);
  let   [content, setcontent] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    content: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
   
});
const onGlobalFilterChange = (e) => {
  const value = e.target.value;
  let _filters = { ...filters };

  _filters['global'].value = value;

  setFilters(_filters);
  setGlobalFilterValue(value);
};
  const fetchData = () => {
    //e.preventDefault()
    setLoading(true)
    let getloginuser = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: 'type',
        
      }),
    };
    return setLoading(true) ,fetch(config.backend_URL + "/getAppcontentforAdmin", getloginuser)
    .then((response) => response.json())
    .then((responseJson) => {
      setLoading(false)
          if (responseJson.status) {
            /*        localStorage.setItem('Id',data.data.data.ADMIN_ID); */
           
            setcontent(responseJson.data)
            
            
            //toast(responseJson.msz);
            
            
          
        } else {
          toast(responseJson.msz);
          
          //setLoading(false)
          
        }
      
    })
    .catch((error) => {
      toast('It will take some time!');
      setLoading(false)
      //console.error(error);
    });

      setLoading(false)
  };
  const viewdata=(id)=>{
    console.log(id)
    navigate(`/editcontent?id=${id}`)    
  }
  const renderHeader = () => {
    return (
      <div class="row">
<div class="col-md-6">

              
<InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search Content" />
         
   
</div>
<div class="col-md-6">
<Link class="dt-button add-new btn btn-primary ms-2 ms-sm-0" tabindex="0" aria-controls="DataTables_Table_0" to={config.front_URL +"/addcontent"} ><span><i class="fa fa-plus me-0 me-sm-1 ti-xs"></i><span class="d-none d-sm-inline-block">Add</span></span></Link></div>

      </div>
      
    );
};
  const header = renderHeader();
  const rowClass = (data) => {
    return {
        'bg-primary': data.category === 'Fitness'
    };
};
const actionBodyTemplate3 = (rowData) => {
  //console.log(index)
 
    return (
      <React.Fragment>
      
        { moment(rowData.createdDate).tz("Israel").format("DD/MM/YYYY h:m")}
      </React.Fragment>
    )
            
   
  
  };
  const actionBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            <button class="btn btn-info" onClick={()=>viewdata(rowData._id)}><i class="fa fa-pencil" aria-hidden="true"></i></button>&nbsp;
        </React.Fragment>
    );
  };
  useEffect(() => {
    //setLoading(true) ;
    fetchData();
  }, []);



  return (
    <div className="container-scroller">
    {loadingInProgress ? <div className="parentdiv"><div className="loaderclsdiv"><ClipLoader className="loadercls" text-align="center" color={'#000'} loading={loadingInProgress}  size={35} /></div></div>: ""}
    {" "}
    <ToastContainer />
  
    <div class="layout-wrapper layout-content-navbar">
    <div class="layout-container">
  
<Aside/>
<div class="layout-page">


<Header/>
    
    <div class="content-wrapper">


<div class="container-xxl flex-grow-1 container-p-y">
  
  

<h4 class="py-3 mb-4">
  
<span class="text-muted fw-light">App Content</span> 
  
</h4>






<div class="card">

<div class="card-datatable table-responsive">
  <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
  <DataTable showGridlines  rowClassName={rowClass} header={header} globalFilterFields={['content']} dataKey="id"  filters={filters} filterDisplay="row" value={content} tableStyle={{ minWidth: '10rem'}} paginator  rows={10} rowsPerPageOptions={[5, 10, 25, 50]}  emptyMessage="No customers found.">
      <Column body={actionBodyTemplate} exportable={false} style={{ width:'17%',minWidth: '2rem',borderTop: "1px solid #ADB5BD" }}></Column>
      <Column field="_id"  sortable header="Id" style={{ minWidth: '2rem',borderTop: "1px solid #ADB5BD" }}></Column>
      <Column field="type" sortable header="Type"   style={{ minWidth: '3rem',borderTop: "1px solid #ADB5BD",padding:"10px" }}></Column>
    <Column field="content" sortable header="Content"   style={{ minWidth: '3rem',borderTop: "1px solid #ADB5BD",padding:"10px" }}></Column>
   
    <Column field="dateTime" sortable header="Updated" body={actionBodyTemplate3} style={{ minWidth: '2rem',borderTop: "1px solid #ADB5BD",padding:"10px" }}></Column>
   
   
</DataTable>
                               
                                    
    </div>
  </div>
</div>


  </div>
 

  
  



<Footer/>

  
 
</div>
</div>
           
            
</div>



</div>
</div>
   
   
    
  );
}

export { Appcontent };
